export default "__VITE_ASSET__b99f1e24__"